import atoms from '../../../atoms'
import { findConstantLabel, priceTagFormatter } from '../../../../constants/utils';
import moment from 'moment';
import constant from '../../../../constants/constant';

const { Search, Table, Pagination,CustomImages } = atoms
const Index = ({ setSearch, cancelListing, setLimitPerPage, setCurrentPage, currentPage, limit, }: any) => {
    const columns = [
        { name: 'Product ID', selector: (row: any) => row?.product?.product_id_display || '-', },
        { name: 'Movement ID', selector: (row: any) => row?.procurement?.procurement_display_id || '-', },
        {
            name: 'Product Type / Frame /Glass Size/Power',
             selector: (row: any) =>
                `${row?.product?.product_type?.name}
         ${row?.product?.rim_type ? findConstantLabel(constant?.PRODUCT_RIM_TYPE, row?.product?.rim_type) : ""}
         ${row?.product?.glass_size}`,
        },
        { name: 'SRP', 
            selector: (row: any) =>priceTagFormatter(row?.product?.product_srp,row?.requested_store?.region || constant.STORE_REGION.INDIA ) || '-', 
        },
        { 
            name: 'Landing Cost', 
            selector: (row: any) =>priceTagFormatter(row?.landing_cost,row?.requested_store?.region || constant.STORE_REGION.INDIA ) || '-',
        },
        { name: 'Date Time', selector: (row:any) => `${row?.createdAt ? moment(row?.updatedAt).format('DD/MM/YYYY , H:mm:ss') : "--"}`, sortable: true },
        { name: 'Cover Photo', cell: (row: any) => <CustomImages src={row?.product?.images?.length>0 && row?.product?.images[0]} />, center: true },
        { name: 'Requested Store Name', selector: (row: any) => row?.requested_store?.store_location || '-',minWidth:"200px" },
        { name: 'Cancelled by Store', selector: (row: any) =>row?.user?.username ? row?.user?.username : " - ", },
        // { name: 'Delivery Boy', selector: (row: any) => row., },
        { name: 'Order ID/Warranty Claim ID', selector: (row: any) => row?.order?.order_id_display ? row?.order?.order_id_display : row?.warranty_claimed_product?.claim_id, },
        { name: 'Status', selector: (row: any) => row.status, },

    ]
    return (
        <div>
            <div className="row align-items-center">
                <div className="col-6">
                    <Search searchCallBack={(e: string) => { setSearch(e) }} />
                </div>
            </div>
            <div>
                <Table
                    AdditionalClassName="add-invertory-table data-table-container"
                    columns={columns}
                    data={cancelListing?.data?.map((item: any) => {
                        return ({
                            ...item,
                            status: item.status === constant._STATUS.CANCELLED ? (<div className="background-light-red border-product-radius"><p className="color-red m-1 p-1">{"Cancelled"}</p></div>) : '',
                        })
                    })}
                />
            </div>
            <div>
                <Pagination
                    totalCount={cancelListing?.count}
                    currentPage={currentPage}
                    totalPages={cancelListing?.totalPages}
                    onChangePage={(page: any) => setCurrentPage(page)}
                    setLimit={(e: number) => setLimitPerPage(e)}
                    limit={limit}
                />
            </div>
        </div>
    )
}

export default Index